import GeoSolutions from "../components/pages/GeoSolutions";

export default function GeoSolutionsPage() {
  return <GeoSolutions />;
}
